import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { UserCheck, X } from "lucide-react";

// Pick the existing client who referred this one. `clients` = [{id,name,phone}], value = client id.
export const ReferrerPicker = ({ clients = [], value, onChange, excludeId }) => {
  const [q, setQ] = useState("");
  const chosen = clients.find((c) => c.id === value);
  if (chosen) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-primary/40 bg-primary/5 px-3 h-11 text-sm" data-testid="referrer-chosen">
        <span className="flex items-center gap-2"><UserCheck className="h-4 w-4 text-primary" />Referred by <b>{chosen.name}</b></span>
        <button type="button" onClick={() => onChange("")} className="text-muted-foreground hover:text-foreground" data-testid="referrer-clear"><X className="h-4 w-4" /></button>
      </div>
    );
  }
  const hits = q.trim().length < 2 ? [] : clients.filter((c) => c.id !== excludeId && ((c.name || "").toLowerCase().includes(q.toLowerCase()) || (c.phone || "").includes(q))).slice(0, 6);
  return (
    <div className="space-y-1" data-testid="referrer-picker">
      <Input placeholder="Who referred them? Search client name…" value={q} onChange={(e) => setQ(e.target.value)} className="h-11 rounded-lg" data-testid="referrer-search" />
      {hits.length > 0 && (
        <div className="rounded-lg border bg-card shadow-sm divide-y">
          {hits.map((c) => (
            <button type="button" key={c.id} onClick={() => { onChange(c.id); setQ(""); }} className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex justify-between" data-testid={`referrer-hit-${c.id}`}>
              <span>{c.name}</span><span className="text-xs text-muted-foreground">{c.phone}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
